"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConsoleLogger = void 0;
const logLevel_1 = require("./logLevel");
const utils_1 = require("./utils");
const abstractStringLogger_1 = require("./abstractStringLogger");
/**
 * A logger that logs to the default console.
 */
class ConsoleLogger extends abstractStringLogger_1.AbstractStringLogger {
    /**
     * Initializes a new instance of the @see ConsoleLogger class.
     * @param minimumLevel The minimum log level this logger accepts for log messages. If not set, LogLevel.Trace will be used.
     */
    constructor(minimumLevel) {
        super(minimumLevel || logLevel_1.LogLevel.Trace);
    }
    /**
     * The real handler for log entries.
     * @param logLevel Entry will be written on this level.
     * @param requestId Guid of the request.
     * @param state The entry to be written. Can be also an object.
     * @param error The error related to this entry.
     * @param formatter Function to create a string message of the state and error.
     */
    logHandler(logLevel, requestId, state, error, formatter) {
        console.log(`${logLevel.toLocaleUpperCase()}: ${utils_1.getUtcDateTimeString()} ${formatter(state, requestId, error)}`);
    }
}
exports.ConsoleLogger = ConsoleLogger;
//# sourceMappingURL=consoleLogger.js.map